export { FullScreenComponent } from './full-screen.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/full-screen/index.ts